import { useQuery } from '@tanstack/react-query';

import * as api from './api';

/** Both finance reports are role-gated; don't retry 403s. */
export function usePnl() {
  return useQuery({
    queryKey: ['finance', 'reports', 'pnl'],
    queryFn: api.getPnl,
    retry: false,
  });
}

export function useRevenueByClient() {
  return useQuery({
    queryKey: ['finance', 'reports', 'revenue-by-client'],
    queryFn: api.getRevenueByClient,
    retry: false,
  });
}
